module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_icon_cross-670697052b866ff743589892f2dcc343.svg";